import ContactForm from "./Components/ContactForm";
import Overlay from "../../../SharedComponents/Overlay";
import { useSelector } from "react-redux";

const Contact = () => {
  const isLoading = useSelector((state) => state.landingPage.isLoading);

  return (
    <div className={"text-color-gray-dark p-0"}>
      {isLoading && <Overlay />}
      <ContactForm></ContactForm>
    </div>
  );
};
export default Contact;
